export const HTML_CLASSES = {
  noScroll: 'no-scroll',
};
